<section class="container-fluid reviews">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-5">
                <h2>Відгуки</h2>
                <p>Ми запросили до використання випадкову вибірку користувачів Anima щодня протягом двох тижнів. Ось їх
                    висновки. Імена замінені з міркувань приватності.
                </p>
                <!--        <div class="line"></div>-->
            </div>
            <div class="col-12 col-lg-7 reviews-area">
                <ng-container *ngFor="let item of reviews">
                    <app-reviews-item [data]="item"></app-reviews-item>
                </ng-container>
                <app-reviews-pager [data]="data" (pageChange)="pageChange($event)"></app-reviews-pager>
            </div>

        </div>

    </div>
</section>

